export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-768w.a0c91b70.webp";